export default {
  REGION: "us-west-2",
  USER_POOL_ID: "us-west-2_GJoG0b0Bd",
  USER_POOL_APP_CLIENT_ID: "5sfc2cs3kd0qhsdvq5ear837h3",
};
